import { isFuture } from 'date-fns';

export function isJobOpeningPaused(pausedAt?: Date | null) {
  return !!pausedAt && !isFuture(pausedAt.setHours(0, 0, 0, 0));
}
